import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  h1,
  > p {
    font-family: AvertaPE;
    font-style: normal;
    font-weight: normal;
  }

  h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: #1b2852;
    margin-bottom: 1px;
  }

  > p {
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: #69769b;
    margin-bottom: 14px;
  }

  flex: 1;
  flex-direction: column;
  text-align: start;
  padding: 40px 16px;

  .centerButton {
    display: flex;
    justify-content: center;
    margin-top: 44px;
  }
`;

export const Question = styled.div`
  margin-top: 36px;
  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #1b2852;

    margin-bottom: 40px;
  }
`;

interface ButtonProps {
  selected: boolean;
}

export const Option = styled.button<ButtonProps>`
  width: 100%;
  background-color: white;
  border: none;
  margin: 0;
  padding: 0;

  p {
    font-weight: ${(props) => (props.selected ? "600" : "normal")};
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.15px;
    color: ${(props) => (props.selected ? "#006BEE" : "#1b2852")};
  }

  .containerAnswer {
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .dash {
    margin-left: -16px;
    margin-right: -16px;
    width: 100% + 16px;
    height: 1px;
    background-color: #d9dff8;
  }
`;
